import React from 'react';
import PropTypes from 'prop-types';
import { ToggleArrow } from 'web-store-modules/packages/web-store-ui-library';


const SizeSelectorItem = ({ text, onClick, showArrow, arrowDown, relative, style, selected }) => {
    const containerStyle = relative ? { position: relative } : {};

    return (
        <div style={{ ...containerStyle, ...style }} className={text == selected ? "size-selector-item pointer selected" : "size-selector-item pointer"} onClick={onClick}>
            <p>{text}</p>
            <span>{showArrow && <ToggleArrow down={arrowDown} style={{ marginTop: '1em' }} />}</span>
        </div>
    );
}

SizeSelectorItem.propTypes = {
    text: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    relative: PropTypes.bool,
    showArrow: PropTypes.bool,
    arrowDown: PropTypes.bool
};

SizeSelectorItem.defaultProps = {
    relative: false,
    showArrow: false
};

export default SizeSelectorItem;
